import React from 'react';

import sAction from 'sAction';
import GlobalSearchDefault from 'ROOT/src/components/globalSearch/globalSearch';
import InputText from 'ROOT/src/components/formElements/InputText';
import GlobalSearchListContainer from './GlobalSearchListContainer';

class GlobalSearch extends GlobalSearchDefault {
    render() {
        const way = this.props.way;
        const lists = this.props.data.results;
        const searchString = this.props.data.searchString;

        const renderLists = [];

        lists.forEach((list, ind) => {
            if (list.get('records').size != 0) {
                renderLists.push(
                    <GlobalSearchListContainer
                        data={list}
                        key={ind}
                        ind={ind}
                        way={way}
                    />,
                );
            } else {
                renderLists.push(
                    <div
                        key={ind}
                        className="globalSearchListContainer emptyListContainer"
                    >
                        <div className="moduleTitle">
                            {sAction.translate('LBL_MODULE_NAME', list.modul)}
                        </div>
                    </div>,
                );
            }
        });

        return (
            <div className="globalSearchContainer">
                <div className="globalSearchHeaderContainer">
                    <InputText
                        containerClassName="globalSearchInput "
                        className="withBorder"
                        type="text"
                        key={searchString}
                        myRef={this.searchInput}
                        onKeyUp={(ev) => this.keyUp(ev)}
                        defaultValue={searchString}
                        placeholder={sAction.translate('LBL_GLOBAL_SEARCH_HEADER_TEXT')}
                    />
                    <div
                        className="icon-search userHeaderButton"
                        onClick={() => this.handleSearch()}
                    />
                </div>
                <div className="globalSearchResultContainer">{renderLists}</div>
            </div>
        );
    }
}

export default GlobalSearch;
